import { Box, Grid } from "@mui/material";
import { OLClearIcon } from "components/CustomIcons/OLClearIcon";
import { DateInput } from "components/FormControls/DateInput";
import { MultiWithModal } from "components/FormControls/MultiWithModal";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { TextInput } from "components/FormControls/TextInput";
import { Toggle } from "components/FormControls/Toggle";
import { useMessage } from "hooks/intl";
import { memo } from "react";
import { useStyles } from "../../TiersForm.styles";

interface Props {
  activeTier: number;
  index: number;
  remove: (index: number) => void;
}

export const Reward = memo(({ activeTier, index, remove }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <Box className={classes.benefitsContainer}>
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <TextInput
            className={classes.fullWidth}
            data-test-id="name"
            label={<RequiredFieldLabel text={message({ id: "benefitName" })} />}
            name={`tiers[${activeTier}].rewards[${index}].name`}
          />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            className={classes.fullWidth}
            data-test-id="code"
            label={<RequiredFieldLabel text={message({ id: "benefitCode" })} />}
            name={`tiers[${activeTier}].rewards[${index}].code`}
          />
        </Grid>
        <Grid item xs={4}>
          <MultiWithModal
            formField={`tiers[${activeTier}].rewards[${index}].labels`}
            label={message({ id: "customAttributes" })}
            placeholder={message({
              id: "addCustomAttribute",
            })}
            data-test-id="custom-attributes"
            maxLength={255}
          />
        </Grid>
        <Grid item xs={4}>
          <DateInput
            label={message({ id: "startAt" })}
            name={`tiers[${activeTier}].rewards[${index}].startAt`}
            data-test-id="start-at"
            fullWidth
            enableClear
          />
        </Grid>
        <Grid item xs={4}>
          <DateInput
            label={message({ id: "endAt" })}
            name={`tiers[${activeTier}].rewards[${index}].endAt`}
            data-test-id="end-at"
            fullWidth
            enableClear
          />
        </Grid>
        <Grid item xs={4}>
          <TextInput
            className={classes.fullWidth}
            data-test-id="value"
            label={message({ id: "value" })}
            name={`tiers[${activeTier}].rewards[${index}].value`}
          />
        </Grid>
        <Grid item xs={12}>
          <Toggle
            label={message({ id: "active" })}
            name={`tiers[${activeTier}].rewards[${index}].active`}
            data-test-id="active"
          />
        </Grid>
      </Grid>
      <div className={classes.clearIconWidth}>
        <OLClearIcon data-test-id="clear" onClick={() => remove(index)} />
      </div>
    </Box>
  );
});
